


import {
  LOAD_PRIMARY_EMOTIONS_BREAKDOWN_SUCCESS, LOAD_SENTIMENT_BREAKDOWN_SUCCESS,
  SEARCH_CHANGE
} from "./full-report-primary-or-sentiment-action-types";

export const loadPrimaryEmotionsToFullReport = primaryEmotionsBreakdown => (
  { type: LOAD_PRIMARY_EMOTIONS_BREAKDOWN_SUCCESS, primaryEmotionsBreakdown}
  );

export const loadSentimentBreakdownToFullReport = sentimentBreakdown => (
  {
    type: LOAD_SENTIMENT_BREAKDOWN_SUCCESS,
    sentimentBreakdown
  }
);


export const searchChange = ({searchValue, primary}) => ({ type: SEARCH_CHANGE, searchValue, primary});


// WEBPACK FOOTER //
// ./src/modules/full-report-primary-or-sentiment/full-report-primary-or-sentiment-action-creators.js